import { Pipe, PipeTransform } from '@angular/core';
import { Booking } from '@greco/booking-events';

@Pipe({ name: 'bookingIncludesResource' })
export class BookingIncludesResource implements PipeTransform {
  transform(booking: Booking, userId?: string | null) {
    return booking?.event?.resourceAssignments.some(assignment => assignment.resource?.groupId === userId);
  }
}
